'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setupStoreAndSagas = exports.isClientHandoffAction = exports.CLIENT_HANDOFF_ACTION = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _server = require('react-dom/server');

var _reduxSaga = require('redux-saga');

var _reactRedux = require('react-redux');

var _reduxTunnel = require('@wh/redux-tunnel');

var _buildSagas = require('./buildSagas');

var _buildSagas2 = _interopRequireDefault(_buildSagas);

var _createStore = require('./createStore');

var _createStore2 = _interopRequireDefault(_createStore);

var _middleware = require('./middleware');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// types


/**
 * renderToString params type
 * @type {RenderToStringParamsType}
 * @public
 */


/**
 * The return value for the renderToString function
 * @type {Promise<{html: string, state: Object}>}
 * @public
 */
var CLIENT_HANDOFF_TYPE = '@@site-base-app-container/CLIENT_HANDOFF';

/**
 * Action type emitted before the server side rendering. This gives you an opportunity to adapt the data that gets
 * passed to the client without affecting rendering.
 * @type {String}
 * @public
 */
var CLIENT_HANDOFF_ACTION = exports.CLIENT_HANDOFF_ACTION = { type: CLIENT_HANDOFF_TYPE };

/**
 * Checks if a given action is a CLIENT_HANDOFF_ACTION action
 * @param {Object} action The action being processed
 * @returns {Boolean} True if the action type is CLIENT_HANDOFF_TYPE, false otherwise
 * @public
 */
var isClientHandoffAction = exports.isClientHandoffAction = function isClientHandoffAction(action) {
    return action && action.type === CLIENT_HANDOFF_TYPE;
};

/**
 * Replaces the generated checksum to allow for components to be rendered only on the server side without having
 * their state sent to the client
 * @param {String} htmlWithProps The html rendered with the full state
 * @param {String} htmlWithoutProps The html rendered with the client only state
 * @returns {string} The final html with it checksum replaced
 * @private
 */
var renderServerOnlyComponents = function renderServerOnlyComponents(htmlWithProps, htmlWithoutProps) {
    var regex = /data-react-checksum="-?\d+"/i;
    var checksum = htmlWithoutProps.match(regex);

    if (checksum && checksum.length > 0) {
        return htmlWithProps.replace(regex, checksum[0]);
    }

    return htmlWithProps;
};

/**
 * Wrapper around react renderToString method
 * @param   {React.Element<*>} App   The application
 * @param   {Object} store The redux store
 * @returns {string} The generated html
 * @private
 */
var renderToStr = function renderToStr(App, store) {
    return (0, _server.renderToString)((0, _jsx3.default)(_reactRedux.Provider, {
        store: store
    }, void 0, (0, _jsx3.default)(App, {})));
};

var setupStoreAndSagas = exports.setupStoreAndSagas = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref2) {
        var App = _ref2.App,
            _ref2$tunnel = _ref2.tunnel,
            tunnel = _ref2$tunnel === undefined ? _reduxTunnel.defaultTunnel : _ref2$tunnel,
            initialState = _ref2.initialState,
            _ref2$middleware = _ref2.middleware,
            middleware = _ref2$middleware === undefined ? [] : _ref2$middleware,
            _ref2$sagas = _ref2.sagas,
            sagas = _ref2$sagas === undefined ? [] : _ref2$sagas,
            _ref2$reducers = _ref2.reducers,
            reducers = _ref2$reducers === undefined ? {} : _ref2$reducers;
        var log, store, task;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        log = tunnel.log;
                        store = (0, _createStore2.default)(reducers, initialState, middleware);
                        task = _middleware.sagaMiddleware.run((0, _buildSagas2.default)(sagas, function (target) {
                            return target.server;
                        }));

                        // Trigger first rendering (to run sagas)

                        renderToStr(App, store);

                        log.info('Dispatching END action');
                        store.dispatch(_reduxSaga.END);
                        _context.next = 8;
                        return task.done;

                    case 8:
                        log.info('Initial saga calculation finished');

                        return _context.abrupt('return', store);

                    case 10:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function setupStoreAndSagas(_x) {
        return _ref.apply(this, arguments);
    };
}();

/**
 * Renders the application to a sring for server side rendering
 * @param {RenderToStringParamsType} params An object with the function parameters
 * @param {Reac.Element<*>} params.App The root application component
 * @param {TunnelType} params.tunnel The tunnel created by the restify server
 * @param {Map<*, *>|string} [params.initialState] The application initial state. Default: Empty object
 * @param {ClientMiddlewareType} [params.middleware] An array of middlewares to be applied to the store. Defaults to an
 * empty array
 * @param {SagaType} [params.sagas] An array of sagas to be run on application start. Each saga is forked. Defaults to
 * an empty array
 * information
 * @param {AppReducersMapType} [params.reducers] key value pair of reducers where the key is the state leaf that the
 * reducer will be responsible for. Defaults to an empty object
 * @param {Boolean} [params.hasServerOnlyComponents] if true will render the required components on the server side only
 * @returns {RenderToStringResponseType} A promise which resolves to the rendered string
 * @public
 */
var renderToString = function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(params) {
        var App, hasServerOnlyComponents, store, htmlWithProps, htmlWithoutProps;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        App = params.App, hasServerOnlyComponents = params.hasServerOnlyComponents;
                        _context2.next = 3;
                        return setupStoreAndSagas(params);

                    case 3:
                        store = _context2.sent;
                        htmlWithProps = renderToStr(App, store);


                        store.dispatch(CLIENT_HANDOFF_ACTION);
                        if (hasServerOnlyComponents) {
                            htmlWithoutProps = renderToStr(App, store);

                            htmlWithProps = renderServerOnlyComponents(htmlWithProps, htmlWithoutProps);
                        }

                        return _context2.abrupt('return', {
                            html: htmlWithProps,
                            state: store.getState()
                        });

                    case 8:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function renderToString(_x2) {
        return _ref3.apply(this, arguments);
    };
}();

exports.default = renderToString;
//# sourceMappingURL=renderToString.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/site-base-app-container/dist/main/renderToString.js
// module id = 537
// module chunks = 0